import React from 'react';
import SEO from '../components/SEO';
import '../styles.css';

function ContactPage() {
  return (
    <div className="page-container">
      <SEO
        title="Contact Virgil"
        description="Contact Virgil for product, account, billing, support, press, or partnership questions."
        url="https://www.virgil.com.ai/contact"
      />
      <section className="content-section static-page-section contact-page-section">
        <h1 className="page-title page-title--wide">Contact Us</h1>
        <p className="page-lead page-lead--compact">
          We'd love to hear from you.
        </p>

        <div className="page-content page-content--polished">
          <div className="contact-method-grid">
            <article className="contact-method-card">
              <p className="static-panel-kicker">General Inquiries</p>
              <h2>Questions about Virgil</h2>
              <p>For general questions about the product, reach out and we'll point you in the right direction.</p>
              <a className="contact-method-link" href="mailto:info@virgil.com.ai">info@virgil.com.ai</a>
            </article>

            <article className="contact-method-card">
              <p className="static-panel-kicker">Support</p>
              <h2>Account and subscription help</h2>
              <p>Need help with your account, billing, or subscription? Our support inbox is the fastest route.</p>
              <a className="contact-method-link" href="mailto:support@virgil.com.ai">support@virgil.com.ai</a>
            </article>

            <article className="contact-method-card">
              <p className="static-panel-kicker">Business & Partnerships</p>
              <h2>Partner with the team</h2>
              <p>Interested in working with Virgil or discussing a partnership? Reach out directly for business inquiries.</p>
              <a className="contact-method-link" href="mailto:haroldrosenthal@virgil.com.ai">haroldrosenthal@virgil.com.ai</a>
            </article>

            <article className="contact-method-card">
              <p className="static-panel-kicker">Press</p>
              <h2>Media requests</h2>
              <p>For press or media-related questions, send a note and we'll follow up with the right information.</p>
              <a className="contact-method-link" href="mailto:info@virgil.com.ai">info@virgil.com.ai</a>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
